import React, { useEffect, useState } from 'react'
import '../../assets/styles/scss/common/_header.scss'
import '../../assets/styles/scss/common/_modal.scss'
import ButtonUC from '../../components/buttonUC';
import LoginModal from '../../pages/login';
import { Form, Modal, Spin, message } from 'antd';
import { GiHamburgerMenu } from 'react-icons/gi';
import FormSignOut from '../../pages/login/form-signOut';
import axiosRc from '../../../src/config/axios-rc'
import { QuestionCircleOutlined } from '@ant-design/icons';
import { clearAllStorage, getJobReqStorage, getUserStorage, rmJobReqStorage, setUserStorage } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import { decryptText, encryptData, encryptText } from '../../utils/cryptoJs';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { isLoadingState, isUpdateUserAfterSaveState, toggleLoginPopUpState } from '../../recoil/states/default';
import homeLogo from '../../assets/images/header/logo.png'
import pdfTutorial from '../../assets/files/tutorial.pdf'
import { ModalRc } from '../modalRc';
import { rmSearchHistoryStorage } from '../../utils/localStorage';

const HeaderHome = () => {
    const [openModalLogin, setOpenModalLogin] = useState(false)
    const [userData, setUserData] = useState(null)
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    const [isShowOtp, setIsShowOtp] = useState(false)
    const [loadingModal, setLoadingModal] = useState(false)
    const [otpEmail, setOtpEmail] = useState(null)
    const [otpRefCode, setOtpRefCode] = useState(null)
    const [isShowStatusWait, setIsShowStatusWait] = useState(false)
    const history = useNavigate()
    const [form] = Form.useForm();
    const [isUpdateUser, setUpdateUserState] = useRecoilState(isUpdateUserAfterSaveState)
    const toggleLoginPopUp = useRecoilValue(toggleLoginPopUpState)
    const location = useLocation();
    const setIsLoading = useSetRecoilState(isLoadingState)
    const [nameUser, setNameUser] = useState(null)


    useEffect(() => {
        if (toggleLoginPopUp) {
            setUserData(null)
            setOpenModalLogin(true)
        }
    }, [toggleLoginPopUp])

    useEffect(() => {
        const user = getUserStorage()
        if (user) {
            setUserData(user)
        }
    }, [isUpdateUser])

    const onFinish = async (value) => {
        setIsLoading(true)
        setUserData({ ...userData, isLoggedIn: true })
        setOpenModalLogin(false)
        setIsShowOtp(false)

        const checkLogin = {
            // expiry: new Date().getTime() + (1 * 60 * 60 * 1000),
            isOtp: true
        }
        const encryptedData = encryptData(checkLogin)
        const _dataLogin = {
            email: form.getFieldValue('email_login'),
            isLoggedIn: false,
            id: null,
            isOtp: true,
            checkLogin: encryptedData
        }
        console.log("71 nameUser", userData, nameUser);

        // get ข้อมูล applicant profile จาก email
        const { data: dataLogin } = await axiosRc.get(`/appProfile/get_by_email/${form.getFieldValue('email_login')}`);
        if (dataLogin) {
            _dataLogin.isLoggedIn = true
            _dataLogin.id = dataLogin.id
            if (dataLogin) {
                setNameUser(dataLogin)
                const delAccStatus = dataLogin.delAccStatus
                const nameUserSet = `${decryptText(dataLogin.title)}${decryptText(dataLogin.firstName)} ${decryptText(dataLogin.lastName)}`
                console.log("76 delAccStatus", delAccStatus);

                if (delAccStatus === 'wait') {
                    console.log("79 delAccStatus", delAccStatus);
                    let propsModal = {
                        type: 'confirm',
                        classModal: 'error',
                        title: 'ขณะนี้บัญชีของคุณอยู่ในกระบวนการลบบัญชี คุณต้องการยกเลิกการลบบัญชีหรือไม่',
                        okText: "ยกเลิกการลบบัญชี",
                        cancelText: 'ปิด',
                        onOk: () => {
                            onOkCancelDel(nameUserSet)
                            setIsShowStatusWait(false)
                        },
                        onCancel: () => {
                            onOkLogOut()
                            setIsShowStatusWait(false)
                        },
                    };
                    ModalRc(propsModal)
                    // <FormStatusWait userData={userData} onOkLogOut={onOkLogOut} setIsShowStatusWait={setIsShowStatusWait} />
                }
                dataLogin.title = decryptText(dataLogin.title);
                dataLogin.firstName = decryptText(dataLogin.firstName);
                dataLogin.lastName = decryptText(dataLogin.lastName);
                dataLogin.gender = decryptText(dataLogin.gender);
                dataLogin.nationality = decryptText(dataLogin.nationality);
                dataLogin.race = decryptText(dataLogin.race);
                dataLogin.religion = decryptText(dataLogin.religion);
                dataLogin.idCard = decryptText(dataLogin.idCard);
                dataLogin.maritalStatus = decryptText(dataLogin.maritalStatus);
                dataLogin.militaryStatus = decryptText(dataLogin.militaryStatus);
                dataLogin.address = decryptText(dataLogin.address);
                dataLogin.province = decryptText(dataLogin.province);
                dataLogin.district = decryptText(dataLogin.district);
                dataLogin.subDistrict = decryptText(dataLogin.subDistrict);
                dataLogin.postCode = decryptText(dataLogin.postCode);
                dataLogin.currentAddress = decryptText(dataLogin.currentAddress);
                dataLogin.currentProvince = decryptText(dataLogin.currentProvince);
                dataLogin.currentDistrict = decryptText(dataLogin.currentDistrict);
                dataLogin.currentSubDistrict = decryptText(dataLogin.currentSubDistrict);
                dataLogin.currentPostCode = decryptText(dataLogin.currentPostCode);
                dataLogin.phone = decryptText(dataLogin.phone);
                dataLogin.facebook = decryptText(dataLogin.facebook);
                if (dataLogin.birthDateStr) {
                    dataLogin.birthDate = decryptText(dataLogin.birthDateStr);
                }
                if (dataLogin.salaryStr) {
                    dataLogin.salary = decryptText(dataLogin.salaryStr);
                }
                // new address
                dataLogin.addressNo = decryptText(dataLogin.addressNo);
                dataLogin.moo = decryptText(dataLogin.moo);
                dataLogin.roomNumber = decryptText(dataLogin.roomNumber);
                dataLogin.building = decryptText(dataLogin.building);
                dataLogin.floor = decryptText(dataLogin.floor);
                dataLogin.village = decryptText(dataLogin.village);
                dataLogin.lane = decryptText(dataLogin.lane);
                dataLogin.road = decryptText(dataLogin.road);
                dataLogin.currentAddressNo = decryptText(dataLogin.currentAddressNo);
                dataLogin.currentMoo = decryptText(dataLogin.currentMoo);
                dataLogin.currentRoomNumber = decryptText(dataLogin.currentRoomNumber);
                dataLogin.currentBuilding = decryptText(dataLogin.currentBuilding);
                dataLogin.currentFloor = decryptText(dataLogin.currentFloor);
                dataLogin.currentVillage = decryptText(dataLogin.currentVillage);
                dataLogin.currentLane = decryptText(dataLogin.currentLane);
                dataLogin.currentRoad = decryptText(dataLogin.currentRoad);
            }
            _dataLogin.name = `${dataLogin.title}${dataLogin.firstName} ${dataLogin.lastName}`
            _dataLogin.data = JSON.stringify(dataLogin)
            _dataLogin.profileImage = getProfileImage(dataLogin)
            setUserData({ ...userData, isLoggedIn: true, name: _dataLogin.name, profileImage: _dataLogin.profileImage })
            // set local storage
            await setUserStorage(_dataLogin)
            setIsLoading(false)
            message.success('เข้าสู่ระบบสำเร็จ')
            setUpdateUserState(!isUpdateUser)
        } else {
            // set local storage
            await setUserStorage(_dataLogin)
            setIsLoading(false)
            // redirect to ApplicantProfile
            const job = await getJobReqStorage()
            console.log('job from prepare login ====>', job)
            if (job) {
                history('/applicantProfile', { state: { jobReq: job } })
                rmJobReqStorage()
            } else {
                history('/applicantProfile')
            }
        }

        const onOkCancelDel = async (valName) => {
            console.log('170=>>', valName, userData);
            const body = {
                email: userData.email,
                approveStatus: "cancel",
                approveByName: encryptText(valName),
            };

            const { data } = await axiosRc.put(`deleteHistory/check_update_del_acc`, body);

            if (data.isStatusWaitCancel) {
                console.log("dataCheck=>>>success");
                message.success('ยกเลิกการลบบัญชีสำเร็จ');
            } else {
                console.log("dataCheck=>>>>>>>>>error");
                message.error('ยกเลิกการลบบัญชีไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ');

            }
        };
    }

    const getProfileImage = (dataLogin) => {
        // return '/jobRequest/2023-06-29/EXQI3M_10111313.jpeg'
        if (dataLogin.rcAttachFile && dataLogin.rcAttachFile.length > 0) {
            // Filter the data based on the file type
            const filteredData = dataLogin.rcAttachFile.filter(item => (item.fileType === 'image/jpeg' || item.fileType === 'image/png') && item.documentType === 'photo');

            if (filteredData && filteredData.length > 0) {
                // Sort the filtered data based on the sort value
                filteredData.sort((a, b) => b.sort - a.sort);

                // Retrieve the first row of data
                const firstRow = filteredData[0];
                return firstRow.filePath
            }
            return null
        }
        return null
    }

    const onFinishFailed = () => {

    }

    const handleLogin = async () => {
        setLoadingModal(true)
        const validEmail = form.getFieldError('email_login')
        if (!form.getFieldValue('email_login') || (validEmail && validEmail.length > 0)) {
            if (!form.getFieldValue('email_login')) {
                form.setFields([{ name: ['email_login'], errors: ['กรุณากรอกอีเมล'] }]);
            } else {
                form.setFields([{ name: ['email_login'], errors: ['อีเมลไม่ถูกต้อง'] }]);
            }
            setLoadingModal(false)
        } else {
            form.validateFields().then(async (values) => {
                const { data } = process.env.REACT_APP_NODE_ENV === 'dev' ?
                    { data: { otp: 111111, refCode: 'REF CODE TEST | OTP is 111111' } } :
                    await axiosRc.get(`/jobList/sent_otp/${form.getFieldValue('email_login')}`);
                // const data = { otp: 111111, refCode: 'REF CODE TEST | OTP is 111111' } // fix for only test.
                if (data && data.refCode) {
                    data.email = form.getFieldValue('email_login')
                    setOtpRefCode(data.refCode)
                    setUserData({ name: userData ? userData.name : null, email: form.getFieldValue('email_login'), isLoggedIn: false })
                }
                setIsShowOtp(true)
            }).catch((error) => {
                // message.warning('บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูล');
                console.error('handleLogin validation error', error);
                setLoadingModal(false)
            });
        }
    }

    const handleLogOut = () => {
        Modal.confirm({
            title: "ออกจากระบบ",
            content: 'ต้องการออกจากระบบใช่หรือไม่?',
            icon: <QuestionCircleOutlined />,
            className: "modal-message modal-message-info",
            okText: "ตกลง",
            cancelText: "ยกเลิก",
            okButtonProps: { className: 'btn-custom' },
            cancelButtonProps: { className: 'btn-clear' },
            onOk: () => {
                onOkLogOut()
            },
            onCancel: () => { },
        })
    }

    const onOkLogOut = async () => {
        await axiosRc.put(`/jobList/logout?email=${form.getFieldValue('email_login')}`);
        form.resetFields()
        setUserData(null)
        setOpenModalLogin(false)
        clearAllStorage()
        setUpdateUserState(!isUpdateUser)
        history('/')
    }

    const onResendOtp = () => {
        setUserData({ name: userData.name, email: form.getFieldValue('email_login'), isLoggedIn: false })
        handleLogin()
    }

    const propsLogin = {
        form,
        openModalLogin,
        setOpenModalLogin,
        onFinish,
        onFinishFailed,
        handleLogin,
        handleLogOut,
        userData,
        isShowOtp,
        setIsShowOtp,
        loadingModal,
        otpEmail,
        otpRefCode,
        onResendOtp,
        setLoadingModal,
        onOkLogOut,
        isShowStatusWait,
        setIsShowStatusWait
    }

    const handleClickLogin = () => {
        setIsShowOtp(false)
        setOpenModalLogin(true)
    }

    const onToggle = () => {
        setIsNavExpanded(!isNavExpanded);
    }

    const isMobile = window.innerWidth <= 992
    const isApplicantProfilePage = location.pathname.toLowerCase().includes('applicantprofile')

    const openPdfInNewTab = () => {
        window.open(pdfTutorial, '_blank');
    };

    const handleLogoClick = () => {
        rmSearchHistoryStorage();

    }

    const Navbar = () => {
        return (
            <>
                <nav className="navigation nav-header">
                <a href="/" onClick={handleLogoClick} className="brand-name">
                    <div className="logo">
                        <img src={homeLogo} alt='' />
                    </div>
                </a>
                    {isMobile && <a className='text-header-mobile text-center' href="/">ประกาศรับสมัครงาน</a>}
                    <GiHamburgerMenu className="hamburger" onClick={onToggle} />
                    <div className={
                        isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
                    }>
                        <ul className="nav-links">
                            {!isMobile && <li><a href="/">ประกาศรับสมัครงาน</a></li>}
                            {isMobile &&
                                <>
                                    <FormSignOut showButton={false} userData={userData} onOkLogOut={onOkLogOut} setOpenModalLogin={setOpenModalLogin} />
                                </>}
                            {userData && userData.isLoggedIn === true &&
                                <>
                                    <li><a href="/ApplicantProfile" >ใบสมัครงานของฉัน</a></li>
                                    <li><a href="/MyJob">ประวัติการสมัครงาน</a></li>
                                </>
                            }
                            {!isMobile ?
                                <li style={{ marginTop: `${userData && userData.isLoggedIn === true ? '0' : (isMobile ? '20' : '0')}px` }}>
                                    <ButtonUC className='btn-clear' onClick={openPdfInNewTab} style={{ width: '150px' }}>
                                        วิธีการสมัครงาน
                                    </ButtonUC>
                                </li> :
                                <li><a href={pdfTutorial} target='_blank' rel='noopener noreferrer'>วิธีการสมัครงาน</a></li>
                            }
                            {(!isApplicantProfilePage ||
                                (isApplicantProfilePage && userData?.isLoggedIn === true)) &&
                                <li className={`${isMobile ? 'flex justify-center' : ''}`}
                                    style={{ marginTop: `${userData && userData.isLoggedIn === true ? (isMobile ? '20' : '0') : '0'}px` }}>
                                    <ButtonUC
                                        className={`button-login ${userData && userData.isLoggedIn === true && !isMobile ? 'btn-signin line-clamp-1' : ' btn-signin'}`}
                                        onClick={userData && userData.isLoggedIn === true && isMobile ? handleLogOut : handleClickLogin}>
                                        {userData && userData.isLoggedIn === true ? (isMobile ? 'ออกจากระบบ' : userData.name) : 'เข้าสู่ระบบ'}
                                    </ButtonUC>
                                </li>
                            }
                        </ul>
                    </div>
                </nav>
                <LoginModal props={propsLogin} />
            </>
        );
    }

    return (
        <>
            <div className='container-header container margin-auto'>
                <Navbar />
            </div>
        </>
    )
}

export default HeaderHome